export default {
  forest_product_cooperatives: {
    name: "Cooperativas de produtos florestais",
    description: "Formação de cooperativas locais para comercializar produtos florestais não madeireiros sustentáveis.",
  },
  satellite_monitoring: {
    name: "Monitoramento por satélite",
    description: "Uso de imagens de satélite para acompanhar mudanças no uso da terra e apoiar a fiscalização.",
  },
  firebreak_construction: {
    name: "Construção de aceiros",
    description: "Criação de barreiras físicas para reduzir a propagação de incêndios.",
  },
  community_patrols: {
    name: "Patrulhas florestais comunitárias",
    description: "Treinamento de equipes locais para monitorar a área e reportar extração ilegal.",
  },
  youth_engagement: {
    name: "Programas de engajamento jovem",
    description: "Criação de oportunidades para jovens participarem de atividades de conservação.",
  },
  agroforestry_training: {
    name: "Treinamento em agrofloresta sustentável",
    description: "Capacitação de agricultores em agrofloresta e práticas de conservação florestal.",
  },
  reforestation: {
    name: "Campanhas de reflorestamento",
    description: "Organização de plantio de espécies nativas para restaurar áreas degradadas.",
  },
  water_protection: {
    name: "Proteção de fontes de água",
    description: "Proteção de riachos, nascentes e áreas ripárias dentro do projeto.",
  },
};
